module.exports = __webpack_public_path__ + "img/emoji-girl-25x25.2d2853c4.png";